import {
  DAMAGE_STATE_CONSEQUENCES,
  DAMAGE_STATES,
} from '@hbrisk/sp3-risk-model-support/components/app/attributes/names/index.js';

const consequencesFieldArrayItemNameFromIndexes = (i, j) =>
  `${DAMAGE_STATES}[${i}]${DAMAGE_STATE_CONSEQUENCES}[${j}]`;

export default consequencesFieldArrayItemNameFromIndexes;
